module.exports = __webpack_public_path__ + "static/media/the_3.d48732a9.png";